import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.section`
	background-color: #fff;
	color: #0f172a;
	text-align: left;
	padding: 32px 4% 20px;
	border-top: 1px solid #f1f5f9;
`;

const Container = styled.div`
	max-width: 1120px;
	margin: 0 auto;
`;

const Columns = styled.div`
	display: grid;
	grid-template-columns: repeat(4, minmax(180px, 1fr));
	gap: 18px 22px;
	align-items: start;

	@media (max-width: 900px) {
		grid-template-columns: repeat(2, minmax(180px, 1fr));
	}

	@media (max-width: 520px) {
		grid-template-columns: 1fr;
	}
`;

const LinkTitle = styled.div`
	color: #c655d6;
	margin-bottom: 10px;
	font-weight: 600;
	font-size: 0.95rem;
	letter-spacing: 0;
	line-height: 1.2;
`;

const LinkList = styled.ul`
	list-style-type: none;
	padding-left: 0;
	margin-top: 0;
	margin-bottom: 0;
`;

const LinkItem = styled.li`
	margin-bottom: 8px;
	color: #334155;
	font-size: 0.9rem;
	line-height: 1.35;
`;

const Link = styled.a`
	text-decoration: none;
	color: inherit;
	&:hover {
		color: #c655d6;
		text-decoration: underline;
	}
`;

const TextUsButton = styled.a`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 10px 14px;
	border-radius: 12px;
	background: #c655d6;
	color: #fff;
	font-weight: 700;
	letter-spacing: 0.2px;
	text-decoration: none;
	box-shadow: 0 8px 20px rgba(198, 85, 214, 0.22);

	&:hover {
		background: #b94bc8;
		color: #fff;
	}
`;

const SocialRow = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	margin-top: 12px;
`;

const SocialLink = styled.a`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 999px;
	background: #f8fafc;
	border: 1px solid #e2e8f0;
	text-decoration: none;

	&:hover {
		border-color: rgba(198, 85, 214, 0.55);
		background: rgba(198, 85, 214, 0.06);
	}
`;

const SocialIcon = styled.img`
	width: 18px;
	height: 18px;
	opacity: 0.75;
`;

const Divider = styled.div`
	height: 1px;
	background: #f1f5f9;
	margin: 18px 0 14px;
`;

const FooterBottom = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 12px 16px;
	align-items: center;
	justify-content: space-between;
`;

const LegalLinks = styled.div`
	display: inline-flex;
	gap: 14px;
	flex-wrap: wrap;
`;

const LegalLink = styled.a`
	color: #64748b;
	text-decoration: none;
	font-size: 0.9rem;

	&:hover {
		color: #c655d6;
		text-decoration: underline;
	}
`;

const Copyright = styled.p`
	color: #94a3b8;
	font-size: 0.9rem;
	margin: 0;
`;

const Footer = () => (
	<Wrapper>
		<Container>
			<Columns>
				<div>
					<LinkTitle>Product</LinkTitle>
					<LinkList>
						<LinkItem>
							<Link href="https://www.chekkit.io/">Overview</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://www.chekkit.io/reviews">
								Reviews
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://www.chekkit.io/messenger">
								Messenger
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://www.chekkit.io/textchat">
								Textchat
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://www.chekkit.io/payments">
								Chekkit Pay
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://www.chekkit.io/pricing">
								Pricing
							</Link>
						</LinkItem>
					</LinkList>
				</div>
				<div>
					<LinkTitle>Links</LinkTitle>
					<LinkList>
						<LinkItem>
							<Link href="https://itunes.apple.com/ca/app/chekkit/id1399027413?mt=8">
								Download for iOS
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://play.google.com/store/apps/details?id=io.chekkit.chekkit">
								Download for Android
							</Link>
						</LinkItem>
						<LinkItem>
							<Link href="https://enterprise.chekkit.io/login">
								Log In
							</Link>
						</LinkItem>

						<LinkItem>
							<Link href="https://enterprise.chekkit.io/register">
								Sign Up
							</Link>
						</LinkItem>
					</LinkList>
				</div>
				<div>
					<LinkTitle>Company</LinkTitle>
					<LinkList>
						<LinkItem>
							<Link href="https://www.chekkit.io/our-reviews">
								Our Reviews
							</Link>
						</LinkItem>
						<LinkItem>
							<Link href="tel:18889197719">Call Us</Link>
						</LinkItem>

						<LinkItem>
							<Link href="mailto:support@chekkit.io">Email Us</Link>
						</LinkItem>
					</LinkList>
				</div>
				<div>
					<LinkTitle>Help</LinkTitle>
					<LinkList>
						<LinkItem>
							<Link href="https://www.chekkit.io/blog">Blog</Link>
						</LinkItem>
						<LinkItem>
							<Link href="https://help.chekkit.io/">
								Help Center
							</Link>
						</LinkItem>
						<LinkItem>
							<TextUsButton href="sms:+18889197719">
								Text us +1 (888) 919-7719
							</TextUsButton>
						</LinkItem>
					</LinkList>
					<SocialRow>
						<SocialLink
							target="_blank"
							rel="noreferrer"
							href="https://facebook.com/getchekkit"
							aria-label="Chekkit on Facebook"
							title="Facebook"
						>
							<SocialIcon
								alt="Facebook"
								src="https://cdn3.iconfinder.com/data/icons/free-social-icons/67/facebook_circle_gray-48.png"
							/>
						</SocialLink>
						<SocialLink
							target="_blank"
							rel="noreferrer"
							href="https://twitter.com/getchekkit"
							aria-label="Chekkit on Twitter"
							title="Twitter"
						>
							<SocialIcon
								alt="Twitter"
								src="https://cdn3.iconfinder.com/data/icons/free-social-icons/67/twitter_circle_gray-48.png"
							/>
						</SocialLink>
						<SocialLink
							target="_blank"
							rel="noreferrer"
							href="https://www.linkedin.com/company/18233108/"
							aria-label="Chekkit on LinkedIn"
							title="LinkedIn"
						>
							<SocialIcon
								alt="LinkedIn"
								src="https://cdn3.iconfinder.com/data/icons/free-social-icons/67/linkedin_circle_gray-48.png"
							/>
						</SocialLink>
					</SocialRow>
				</div>
			</Columns>

			<Divider />
			<FooterBottom>
				<LegalLinks>
					<LegalLink href="https://www.chekkit.io/privacy-policy">
						Privacy Policy
					</LegalLink>
					<LegalLink href="https://www.chekkit.io/terms-of-use">
						Terms of Use
					</LegalLink>
				</LegalLinks>
				<Copyright>
					© {new Date().getFullYear()} Chekkit. All rights reserved.
				</Copyright>
			</FooterBottom>
		</Container>
	</Wrapper>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/index/Footer.js